import InitComponent from "Modules/InitComponent";
import QuickNavigation from "./components/QuickNavigation.vue";

const quickNavigation = document.getElementById("quick-navigation");

// replaceHost, because the row is sticky and a sticky element can only travel
// inside its containing block. Mounting into the host leaves it wrapped in a
// box exactly its own height, which is no travel at all — Vue 2 replaced the
// host and Vue 3 keeps it, so the row stopped sticking on that upgrade. The
// component renders the same id and class the host carries, so what it stands
// in for is what the server drew as a fallback.
const initComponent = new InitComponent({
  components: { QuickNavigation },
  replaceHost: true,
  selectors: quickNavigation,
  template: "<QuickNavigation />",
});

initComponent.init();
